/**
 * 存储localStorage
 */
export const setStore = (name, content) => {
  if (!name) return;
  if (typeof content !== 'string') {
    content = JSON.stringify(content);
  }
  window.localStorage.setItem(name, content);
}

/**
 * 获取localStorage
 */
export const getStore = name => {
  if (!name) return;
  return window.localStorage.getItem(name);
}

/**
 * 删除localStorage
 */
export const removeStore = name => {
  if (!name) return;
  window.localStorage.removeItem(name);
}

/**
 * 默认的cookie写入方法
 * @param name
 * @param value
 */
export const setCookie = (name,value) => {
  var d = new Date();
  var exdays = 1;
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  var expires = "expires=" + d.toUTCString();
  console.info(name + "=" + value + "; " + expires);
  document.cookie = name + "=" + value + "; " + expires;
  console.info(document.cookie);
}
/**
 * 获取Cookie中的值
 * @param objName
 * @returns
 */
export const getCookie = objName => {//获取指定名称的cookie的值
  var arrStr = document.cookie.split("; ");
  for (var i = 0; i < arrStr.length; i++) {
    var temp = arrStr[i].split("=");
    if (temp[0] == objName){
      return decodeURI(temp[1]);
    }
  }
}

/**
 * 清除指定cookie
 * @param name
 * @returns
 */
export const delCookie = name => {
  var exp = new Date()
  exp.setTime(exp.getTime() - 1)
  var cval = setCookie(name)
  if (cval && cval != null) {
    document.cookie = name + '=' + cval + ';expires=' + exp.toGMTString()
  }
}

/**
 * 清除所有cookie
 * @param name
 * @returns
 */
function clearCookie () {
  var keys = document.cookie.match(/[^ =;]+(?=\=)/g)
  if (keys) {
    for (var i = keys.length; i--;) {
      document.cookie = keys[i] + '=0;expires=' + new Date(0).toUTCString()
    }
  }
}

/**
 * 获取style样式
 */
export const getStyle = (element, attr, NumberMode = 'int') => {
  let target;
  // scrollTop 获取方式不同，没有它不属于style，而且只有document.body才能用
  if (attr === 'scrollTop') {
    target = element.scrollTop;
  }else if(element.currentStyle){
    target = element.currentStyle[attr];
  }else{
    target = document.defaultView.getComputedStyle(element,null)[attr];
  }
  //在获取 opactiy 时需要获取小数 parseFloat
  return  NumberMode == 'float'? parseFloat(target) : parseInt(target);
}

/**
 * 身份证的正则
 */
export const isCardNo = (idcode) => {
  // 加权因子
  var weight_factor = [7,9,10,5,8,4,2,1,6,3,7,9,10,5,8,4,2];
  // 校验码
  var check_code = ['1', '0', 'X' , '9', '8', '7', '6', '5', '4', '3', '2'];

  var code = idcode + "";
  var last = idcode[17];//最后一位

  var seventeen = code.substring(0,17);

  // ISO 7064:1983.MOD 11-2
  // 判断最后一位校验码是否正确
  var arr = seventeen.split("");
  var len = arr.length;
  var num = 0;
  for(var i = 0; i < len; i++){
    num = num + arr[i] * weight_factor[i];
  }

  // 获取余数
  var resisue = num%11;
  var last_no = check_code[resisue];

  // 格式的正则
  // 正则思路
  /*
  第一位不可能是0
  第二位到第六位可以是0-9
  第七位到第十位是年份，所以七八位为19或者20
  十一位和十二位是月份，这两位是01-12之间的数值
  十三位和十四位是日期，是从01-31之间的数值
  十五，十六，十七都是数字0-9
  十八位可能是数字0-9，也可能是X
  */
  var idcard_patter = /^[1-9][0-9]{5}([1][9][0-9]{2}|[2][0][0|1][0-9])([0][1-9]|[1][0|1|2])([0][1-9]|[1|2][0-9]|[3][0|1])[0-9]{3}([0-9]|[X])$/;

  // 判断格式是否正确
  var format = idcard_patter.test(idcode);

  // 返回验证结果，校验码和格式同时正确才算是合法的身份证号码
  return last === last_no && format ? true : false;
}

/**
 * 图片的裁剪
 */
export const getDrawImageFile = (file) => {
  var canvas =  document.createElement('canvas')
  // 获取对应的CanvasRenderingContext2D对象(画笔)
  var context = canvas.getContext('2d')
  // 创建新的图片对象
  var img = new Image();

  // 指定图片的DataURL(图片的base64编码数据)
  img.src = file.content
  img.onload = () => {
    if(file.content.length>10000){
      // 指定canvas画布大小，该大小为最后生成图片的大小
      canvas.width = img.width/3
      canvas.height = img.height/3
      /* drawImage画布绘制的方法。(0,0)表示以Canvas画布左上角为起点，400，300是将图片按给定的像素进行缩小。*/
      /* 如果不指定缩小的像素，图片将以图片原始大小进行绘制，图片像素如果大于画布将会从左上角开始按画布大小部分绘制图片，最后得到的图片就是张局部图。图片小于画布就会有黑边。*/
      context.drawImage(img, 0, 0, img.width/3, img.height/3)
    }else{
      // 指定canvas画布大小，该大小为最后生成图片的大小
      canvas.width = img.width
      canvas.height = img.height
      /* drawImage画布绘制的方法。(0,0)表示以Canvas画布左上角为起点，400，300是将图片按给定的像素进行缩小。*/
      /* 如果不指定缩小的像素，图片将以图片原始大小进行绘制，图片像素如果大于画布将会从左上角开始按画布大小部分绘制图片，最后得到的图片就是张局部图。图片小于画布就会有黑边。*/
      context.drawImage(img, 0, 0, img.width, img.height)
    }
    // 将绘制完成的图片重新转化为base64编码，file.file.type为图片类型，0.92为默认压缩质量
    file.content = canvas.toDataURL(file.file.type, 0.4)
    // 最后将base64编码的图片保存到数组中，留待上传。
  }
}

/**
 * 获得参数search
 */
export const GetQueryString = (name) => {
  var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
  var r = window.location.search.substr(1).match(reg);
  // debugger
  if(r != null) {
    return unescape(r[2]);
  }
  return '';
}

/**
 * 获得参数hash
 */
export const getQueryVariable = (variable) =>
{
  var query = window.location.hash.substring(1);
  var vars = query.split("&");
  for (var i=0;i<vars.length;i++) {
    var pair = vars[i].split("=");
    if(pair[0] == variable){return pair[1];}
  }
  return("");
}


//判断是否是小程序环境
function doMiniProgram(callback) {
  console.log('判断环境')
  try {
    //小程序环境设置分享
    var ua = window.navigator.userAgent.toLowerCase();
    //判断是否是微信环境
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      //微信环境
      wx.miniProgram.getEnv(function (res) {
        if (res.miniprogram) {
          callback();
        }
      })
    }
  }
  catch (ex) {
    console.log(ex);
  }
}

//设置小程序分享
export const setMiniProgramShare =(shareTitle, imageUrl, shareUrl) =>
{
  console.log('设置1234567890')
  try {
    doMiniProgram(function () {
      // 小程序环境下逻辑
      console.log('小程序环境')
      wx.miniProgram.postMessage({ data: { title: shareTitle, path: shareUrl, imageUrl: imageUrl } })
    })
    // doMiniProgram(function () {
    //
    // });
  }
  catch (ex) {
    console.log(ex);
  }
}

export const isPhone = (phone) => {
  let pattern = /^1[3456789]\d{9}$/
  return pattern.test(phone);
}








// WEBPACK FOOTER //
// ./src/utils/mUtil.js